import {useState} from 'react';
import AdminNavbar from './AdminNavbar';
import {useSelector} from 'react-redux';
import NavLi from './NavLi';
import {hasPermissionToFeature} from "../helpers/helperFunctions";
import {
  FEATURE_BANNER, FEATURE_BLOG, FEATURE_CAMPAIGN,
  FEATURE_CAMPAIGN_REPORT,
  FEATURE_CART_REPORTING,
  FEATURE_DYNAMIC_UI,
  FEATURE_FOCUS_ITEM,
  FEATURE_MANAGE_LOCATION, FEATURE_MANAGE_USER,
  FEATURE_NOTIFICATION,
  FEATURE_NOTIFICATION_REPORT,
  FEATURE_PAYMENT_VERIFICATION, FEATURE_PREDICTION, FEATURE_PRESCRIPTION,
  FEATURE_PRODUCT_FAQ,
  FEATURE_REMOTE_CONFIG, FEATURE_SHIFT,
  FEATURE_WISHLIST_REPORTING,
  FEATURE_REWARD_DASHBOARD,
  FEATURE_FULFILLMENT_OPERATOR,
} from "../pages/user/constants";
import {Link} from "react-router-dom";

export default function Sidebar({isMobileViewSelected = true}) {
  const [showSidebar, setShowSidebar] = useState('-left-64');
  const _user = useSelector((state) => state.authToken.user);

  return (
    <>
      <AdminNavbar
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
        isMobileViewSelected={isMobileViewSelected}
      />

      <div
        className={`h-screen fixed top-0${isMobileViewSelected ? ' xl:left-0' : ''} ${showSidebar} flex-row flex-nowrap overflow-hidden shadow-xl bg-white w-64 z-10 transition-all duration-300`}
      >
        <div className="relative flex-col items-stretch min-h-full px-0 flex-nowrap">

          <Link to="/"><h6 className="px-6 py-3 font-semibold">Jeevee Admin</h6></Link>
          <div className="flex flex-col">
            <hr className="min-w-full"/>
            <ul className="flex flex-col min-w-full px-6 py-3 overflow-y-auto list-none scrollbar "
                style={{height: "calc(100vh - 50px)"}} onClick={() => setShowSidebar('-left-64')}>
              <>
                {hasPermissionToFeature(_user, FEATURE_MANAGE_USER) &&
                  <NavLi title="Manage User" to="/users" iconName="manage_accounts"/>}
                {hasPermissionToFeature(_user, FEATURE_DYNAMIC_UI) &&
                  <NavLi title="Dynamic Uis" to="/dynamic-uis" iconName="view_quilt"/>}
                {hasPermissionToFeature(_user, FEATURE_BANNER) &&
                  <NavLi title="Banners" to="/banners" iconName="dynamic_feed"/>}
                {hasPermissionToFeature(_user, FEATURE_NOTIFICATION) &&
                  <NavLi title="Notification" to="/notification" iconName="notifications"/>}
                {hasPermissionToFeature(_user, FEATURE_NOTIFICATION_REPORT) &&
                  <NavLi title="Notification Report" to="/notification-report" iconName="backup_table"/>}
                {hasPermissionToFeature(_user, FEATURE_FOCUS_ITEM) &&
                  <NavLi title="Focus Items" to="/focus-items" iconName="category"/>}
                {/*{hasPermissionToFeature(_user, FEATURE_DYNAMIC_UI) &&<NavLi title="Events" to="/events" iconName="event"/>}*/}
                {hasPermissionToFeature(_user, FEATURE_REMOTE_CONFIG) &&
                  <NavLi title="Remote Config" to="/remote-config" iconName="settings_remote"/>}
                {hasPermissionToFeature(_user, FEATURE_BLOG) &&
                  <NavLi title="Blogs" to="/blogs" iconName="edit_note"/>}
                {/*{hasPermissionToFeature(_user, FEATURE_DYNAMIC_UI) &&<NavLi title="Doctor" to="/doctor" iconName="person"/>}*/}
                {/*{hasPermissionToFeature(_user, FEATURE_DYNAMIC_UI) &&<NavLi title="Consultation" to="/consultation?page=1" iconName="phone"/>}*/}
                {/*{hasPermissionToFeature(_user, FEATURE_DYNAMIC_UI) &&<NavLi title="Pharmacist" to="/pharmacists" iconName="medication"/>}*/}
                {/*{hasPermissionToFeature(_user, FEATURE_DYNAMIC_UI) &&<NavLi title="Delivery" to="/delivery" iconName="person_pin_circle" />}*/}
                {/*{hasPermissionToFeature(_user, FEATURE_DYNAMIC_UI) &&<NavLi title="Nurse" to="/nurse" iconName="person" />}*/}
                {/*{hasPermissionToFeature(_user, FEATURE_DYNAMIC_UI) &&<NavLi title="Business" to="/business" iconName="business"/>}*/}
                {hasPermissionToFeature(_user, FEATURE_PAYMENT_VERIFICATION) &&
                  <NavLi title="Payment Verification" to="/payment-verification" iconName="credit_card"/>}
                {hasPermissionToFeature(_user, FEATURE_CAMPAIGN_REPORT) &&
                  <NavLi title="Campaign Report" to="/campaign-report" iconName="assignment"/>}
                {hasPermissionToFeature(_user, FEATURE_MANAGE_LOCATION) &&
                  <NavLi title="Manage Location" to="/location-service" iconName="place"/>}
                {hasPermissionToFeature(_user, FEATURE_CART_REPORTING) &&
                  <NavLi title="Cart Reporting" to="/cart-list" iconName="list"/>}
                {hasPermissionToFeature(_user, FEATURE_WISHLIST_REPORTING) &&
                  <NavLi title="Wishlist Reporting" to="/wish-list" iconName="list"/>}
                {hasPermissionToFeature(_user, FEATURE_PRODUCT_FAQ) &&
                  <NavLi title="Product FAQs" to="/faq" iconName="forum"/>}
                {hasPermissionToFeature(_user, FEATURE_PREDICTION) &&
                  <NavLi title="Prediction" to="/predictions" iconName="forum"/>}


                {hasPermissionToFeature(_user, FEATURE_CAMPAIGN) &&
                  <NavLi title="Campaign" to="/campaigns" iconName="campaign"/>}
                {hasPermissionToFeature(_user, FEATURE_SHIFT) &&
                  <NavLi title="Shifts" to="/shifts" iconName="calendar_view_week"/>}
                {hasPermissionToFeature(_user, FEATURE_PRESCRIPTION) &&
                  <NavLi title="Prescription" to="/prescription" iconName="list"/>}
                {hasPermissionToFeature(_user, FEATURE_REWARD_DASHBOARD) &&
                  <NavLi title="All Transactions" to="/transactions" iconName="receipt_long"/>}
                {hasPermissionToFeature(_user, FEATURE_FULFILLMENT_OPERATOR) &&
                  <NavLi title="Fulfillment Operators" to="/fulfillment-operators" iconName="group"/>}
              </>

            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
